import { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { EuiFormLabel, EuiComboBox, EuiFlexGroup } from '@elastic/eui';
import { MODEL_VERSIONS } from 'apollo-client/queries/getAvailableModelVersions';
import { modelVersions } from 'cache';
import { Query, QueryGetAvailableModelVersionsArgs } from 'generated/graphql';
import { useLocalCache } from 'hooks/useLocalCache';
import { useIntl } from 'react-intl';
import { yearsOptions } from '.';
import { SelectAll } from 'components/SelectAll';
import { FormattedMessage } from 'react-intl';

import * as S from './FiltersSidebar.styles';

export const ModelVersionsFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();
  const [selectAll, setSelectAll] = useState(false);

  const [onGetAvailableModelVersions, { loading, data }] = useLazyQuery<Query, QueryGetAvailableModelVersionsArgs>(
    MODEL_VERSIONS,
    {
      fetchPolicy: 'network-only',
    }
  );

  const getInputVechicleYears = (): number[] | undefined => {
    const options = yearsOptions;
    const max = localFilters?.data?.vehicleRegistrationDateISO8601?.max;
    const min = localFilters?.data?.vehicleRegistrationDateISO8601?.min;
    const vehicleYears =
      max && min
        ? options.slice(
            options.indexOf(parseInt(min as unknown as string)),
            options.indexOf(parseInt(max as unknown as string) + 1)
          )
        : undefined;
    return vehicleYears;
  };

  const handleSearchChange = (e: string): void => {
    e.length > 2 ? setSelectAll(true) : setSelectAll(false);

    onGetAvailableModelVersions({
      variables: {
        inputModelVersion: e,
        inputBrandNames: localFilters?.data?.brandNames?.length ? localFilters?.data?.brandNames : undefined,
        inputModelNames: localFilters?.data?.modelNames?.length ? localFilters?.data?.modelNames : undefined,
        inputVehicleYears: localFilters?.data?.modelYear?.length
          ? localFilters?.data?.modelYear
          : getInputVechicleYears(),
      },
    });
  };
  const handleAvailableModelVersions = (): void => {
    onGetAvailableModelVersions({
      variables: {
        inputModelVersion: null,
        inputBrandNames: localFilters?.data?.brandNames?.length ? localFilters?.data?.brandNames : undefined,
        inputModelNames: localFilters?.data?.modelNames?.length ? localFilters?.data?.modelNames : undefined,
        inputVehicleYears: localFilters?.data?.modelYear?.length
          ? localFilters?.data?.modelYear
          : getInputVechicleYears(),
      },
    });
  };
  return (
    <S.SidebarFilterWrapper>
      <EuiFlexGroup justifyContent="spaceBetween">
        <EuiFormLabel>{formatMessage({ id: 'filters.modelVersions.label' })}</EuiFormLabel>
        {selectAll && (
          <SelectAll
            onClick={(): void => {
              modelVersions(data?.getAvailableModelVersions?.modelVersions || []);
              setSelectAll(false);
            }}
          >
            <FormattedMessage id="filters.selectAll" defaultMessage="Seleziona Tutti" />
          </SelectAll>
        )}
      </EuiFlexGroup>
      <EuiComboBox
        async
        isLoading={loading}
        placeholder={formatMessage({ id: 'filters.modelVersions.placeholder' })}
        options={
          data?.getAvailableModelVersions?.modelVersions?.map(({ label, eurotaxCode }) => ({
            label,
            value: eurotaxCode,
          })) ?? []
        }
        selectedOptions={localFilters?.data?.modelVersions?.map((x: { label: string; value: string }) => ({
          label: x?.label,
          value: x?.value,
        }))}
        onSearchChange={handleSearchChange}
        onClick={handleAvailableModelVersions}
        onChange={(x): void => {
          modelVersions(x?.map(({ value, label }) => ({ value, label })));
        }}
      />
    </S.SidebarFilterWrapper>
  );
};
